import script from "./AppSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSelect.vue?vue&type=script&setup=true&lang=js"

import "./AppSelect.vue?vue&type=style&index=0&id=3c5be92e&lang=css"

const __exports__ = script;

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem});
